import React from 'react';
export function Footer() {
  return <footer className="w-full bg-gray-900 text-white py-12 px-4" data-id="element-21">
      <div className="max-w-7xl mx-auto" data-id="element-22">
        <div className="text-center mb-8" data-id="element-23">
          <h3 className="text-2xl font-bold text-red-500 mb-2" data-id="element-24">
            Mega Pack Artística Lista
          </h3>
          <p className="text-gray-400" data-id="element-25">
            Recursos educativos para docentes apasionados.
          </p>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center" data-id="element-26">
          <p className="text-gray-400 text-sm mb-2" data-id="element-27">
            © 2026 Todos los derechos reservados.
          </p>
          <p className="text-gray-500 text-sm" data-id="element-28">
            Hecho con ❤️ para la comunidad educativa.
          </p>
        </div>
      </div>
    </footer>;
}